import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';
import styled from '@emotion/styled';
import { Environment } from '@react-three/drei';

function Model({ url }) {
  const { scene } = useGLTF(url);
  return <primitive object={scene} />;
}

const GLBViewerContainer = styled('div')({
  backgroundColor: '#F0F0F0',
  width: "65vh",
  height: "65vh",
  display: 'flex',
  alignSelf: "flex-start",
});

const GLBViewer = ({ fileUrl }) => {
  return (
    <GLBViewerContainer>
      <Canvas style={{ height: '100%', width: '100%', display: "flex", justifyContent: "flex-start" }}>
        <Suspense fallback={null}>
          <Environment
            files="/Ref.hdr"
            environmentIntensity={1.5}
            environmentRotation={[Math.PI, Math.PI / 2, 0]}
          />
          <Model url={fileUrl} />
        </Suspense>
        <OrbitControls />
      </Canvas>
    </GLBViewerContainer>
  );
}

export default GLBViewer